// Typelizer digest fcda686fb50cae60a82bb2d963fd317d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /invitations/:token */
  show: (
    params: { token: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/invitations/:token', params, options),
    method: 'get',
  }),
}
